export default "__VITE_ASSET__B6TeIfcd__"